import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
var _excluded = ["empty", "to"];
var _effectorFileName = "/builds/gmini/front-common/src/Explorer/Nodes/NodeLayout.tsx";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import { Link } from 'react-router-dom';
import { IconButton, ListItem, ListItemIcon, ListItemSecondaryAction, ListItemText, styled } from '@mui/material';
import { MoreVert } from '@mui/icons-material';
import { LongText, Tooltip } from '@gmini/ui-kit';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var ExplorerLayout = /*#__PURE__*/React.memo(function (props) {
  var onClick = props.onClick,
      onMouseOver = props.onMouseOver,
      onMouseLeave = props.onMouseLeave,
      className = props.className,
      opened = props.opened,
      handleOpen = props.handleOpen,
      onContextMenu = props.onContextMenu,
      icon = props.icon,
      textIsLong = props.textIsLong,
      setTextIsLong = props.setTextIsLong,
      pending = props.pending,
      hover = props.hover,
      node = props.node,
      to = props.to,
      empty = props.empty,
      tooltipTitle = props.tooltipTitle,
      noMaxWidth = props.noMaxWidth;
  return /*#__PURE__*/_jsxs(Body, {
    to: to,
    onClick: onClick,
    ContainerComponent: "div",
    ContainerProps: {
      onMouseOver: onMouseOver,
      onMouseLeave: onMouseLeave
    },
    className: className,
    empty: !!empty,
    selected: !!opened,
    onDoubleClick: handleOpen,
    onContextMenu: onContextMenu,
    "data-test-item-id": node.id,
    "data-test-item-type": node.type,
    "data-test-item-name": node.title,
    "data-test-item-level": node.nestingLevel - 1,
    children: [/*#__PURE__*/_jsx(ListItemIcon, {
      children: icon
    }), /*#__PURE__*/_jsx(ListItemText, {
      primaryTypographyProps: {
        noWrap: true
      },
      children: /*#__PURE__*/_jsx(Tooltip, {
        PopperProps: {
          popperOptions: {
            modifiers: [{
              name: 'offset',
              enabled: textIsLong,
              options: {
                offset: [0, 25]
              }
            }]
          }
        },
        placement: "bottom",
        title: tooltipTitle || '',
        fillAvailable: true,
        noMaxWidth: noMaxWidth,
        children: /*#__PURE__*/_jsx(LongText, {
          noMaxWidth: noMaxWidth,
          partSize: 20,
          onCutOff: setTextIsLong,
          children: node.title
        })
      })
    }), /*#__PURE__*/_jsx(ListItemSecondaryAction, {
      children: hover && /*#__PURE__*/_jsx(IconButton, {
        disabled: pending,
        onClick: onContextMenu,
        "data-test-id": "showMenu",
        size: "small",
        edge: "end",
        children: /*#__PURE__*/_jsx(MoreVert, {})
      })
    })]
  });
});
ExplorerLayout.displayName = 'ExplorerLayout';
var Body = styled(
/*#__PURE__*/
// eslint-disable-next-line react/display-name
React.forwardRef(function (_ref, ref) {
  var empty = _ref.empty,
      to = _ref.to,
      other = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/_jsx(ListItem, _objectSpread({
    ref: ref,
    component: to ? Link : undefined,
    button: true,
    disableRipple: true,
    dense: true,
    to: to // eslint-disable-next-line @typescript-eslint/no-explicit-any

  }, other));
}))(function (_ref2) {
  var empty = _ref2.empty;
  return {
    // eslint-disable-next-line no-undefined
    cursor: empty ? 'grab' : undefined
  };
});